
















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { ChartReportsService } from '../services/ChartReportsService';
import { Point } from '../models/point';
import { ChartReports } from '../models/chartReports';
import { Config } from '@/utils/Config';
import { Consoler } from '@/utils/Consoler';

@Component
export default class MapLeftSidebar extends Vue {
  @Prop() private year!: number;
  @Prop() private week!: number | null;
  @Prop() private selectedPoint!: Point;

  private chartReports: ChartReports | null = null;
  private loadingChartReports: boolean = false;
  private error: boolean = false;

  private readonly EventNameClose: string = 'close';

  private get chartOptions() {
    if (this.chartReports === null) {
      return {};
    }

    return {
      chart: {
        type: 'bar',
        height: 430
      },
      plotOptions: {
        series: {
          color: Config.Settings.ChartsPrimaryColor,
          minPointLength: 2
        }
      },
      tooltip: {
        valueSuffix: ' ' + this.$t('pcs')
      },
      title: {
        text: ''
      },
      xAxis: {
        categories: this.chartReports.weeks.map((w) => {
          const text = this.$t('week') + ' ' + w.week + ' ' + w.year;
          if (w.week === this.week) {
            return '<span style="font-weight: bold;">' + text + '</span>';  
          }
          return text;
        })
      },
      yAxis: {
        title: {
          text: this.$t('mapLeftSidebar.chart.yAxisTitle')
        },
        softMax: 100
      },
      series: [{
        name: this.$t('mapLeftSidebar.chart.seriesName'),
        data: this.chartReports.weekQuantities,
        showInLegend: false
      }],
      credits: false
    }
  }

  // Watch 'selectedPoint' for changes
  @Watch('selectedPoint', { immediate: true, deep: false })
  onSelectedPointChange() {
    this.loadChartReports();
  }

  private loadChartReports(): Promise<any> {
    this.chartReports = null;

    if (this.selectedPoint === null) {
      return Promise.resolve();
    }

    this.loadingChartReports = true;
    this.error = false;

    return ChartReportsService.getChartReports(this.year, this.selectedPoint.trapGroupId)
      .then(response => {          
        const chartReports: ChartReports = response && response.data;
        Consoler.debugLog('Successfully fetched chart reports from API', chartReports);
        this.chartReports = chartReports;
      })
      .catch(error => {
        Consoler.debugWarn('Failed to fetch chart reports from API', error);
        this.error = true;
      })
      .finally(() => {
        this.loadingChartReports = false;
      });
  }

  private onCloseClick() {
    this.$emit(this.EventNameClose);
  }
}
